import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController
} from "ionic-angular";
import { Http } from "@angular/http";
import { ViewController } from "ionic-angular";
import config from "../../config/config";
import { HomePage } from '../home/home';


/**
 * Generated class for the ModalInscricaoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-modal-inscricao",
  templateUrl: "modal-inscricao.html"
})
export class ModalInscricaoPage {
  usuario: any;
  form: any = {
    festa:'Garden'
  };
  local: any = 'fundao';
  inscevasetravado = true;
  evento: any;
  checkado: any;
  saindode: any;
  constructor(
    public navCtrl: NavController,
    private alertCtrl: AlertController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    private _http: Http
  ) { }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.inscevasetravado = false;
    this.evento = this.navParams.get("ev");
    this.saindode = this.usuario.saindode;
    console.log(this.usuario)
    this.local = this.usuario.local;
    // this.form = this.usuario;  
  } 
  inscrever(form) {
    if (!this.checkado) { 
      let alert = this.alertCtrl.create({
        title: "Importante",
        message:
          "É necessário concordar com os termos acima",
        buttons: [
          {
            text: "OK",
            handler: () => {
            }
          }
        ],
        enableBackdropDismiss: false
      });
      alert.present();
      return true

    } else {
      form.usuario = this.usuario.id;

      form.evento = this.evento.id;
      if(form.festa == 'Sorteio'){
        form.trans = 'sorteio';
      }
      if (Object.keys(form).length != 5) {
        let alert = this.alertCtrl.create({
          title: "Por Favor",
          message:
            "Por favor Preencha Opções de Transporte.",
          buttons: [
            {
              text: "OK",
              handler: () => {
              }
            }
          ],
          enableBackdropDismiss: false
        });
        alert.present();
        return true

      }

      let loading = this.loadingCtrl.create({
        content: "Aguarde"
      });
      loading.present();


      this._http
        .post(config.urlAPI + "evento/inscricao", form, {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          loading.dismiss();
          if (res == 'Seu cadastro foi realizado com sucesso.') {
            let alert = this.alertCtrl.create({
              cssClass: "com-image",
              title: "",
              message: '<img src="./assets/imgs/pop-up-2.png">' + '<p> A confirmação pode ser baixada no botão abaixo.</p>',
              buttons: [
                {
                  text: "OK",
                  handler: () => {
                    this.baixarComprovante();

                  }
                }
              ],
              enableBackdropDismiss: false
            });
            alert.present();
          } else {
            let alert = this.alertCtrl.create({
              title: "",
              message: res,
              buttons: [
                {
                  text: "OK",
                  handler: () => {
                    this.navCtrl.setRoot(HomePage);

                  }
                }
              ],
              enableBackdropDismiss: false
            });
            alert.present();
          }
        })
        .catch(error => {
          loading.dismiss();
          console.log(error);
        });
    }
  }
  contadordePalavras(e) {
    let palavras = e.target.value.split(' ')
    if (palavras.length >= 290) {
      this.form.resumo = e.target.value.substr(0, e.target.value.length - 1);
    }
  }
  contadordePalavras2(e) {
    let palavras = e.target.value.split(' ')
    if (palavras.length >= 20) {
      this.form.titulo = e.target.value.substr(0, e.target.value.length - 1);
    }
  }
  checkTelefone1(data) {
    let numero = null;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.form.telefone = numero;
    }
  }
  backHome() {
    this.viewCtrl.dismiss();
  }
  autorizo(env) {
    this.checkado = env;
  }
  baixarComprovante() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    console.log('baixar');
    const self = this;
    var iframe = document.querySelector("#iframe-carteirinha");
    iframe.setAttribute('src', 'https://backend.homologacao.sintufrj.org.br/public/api/gerar/validacao/' + this.usuario.id + '/' + this.evento.id);
    document.getElementById("iframe-carteirinha").click();
    setTimeout(function () {
      loading.dismiss();
      self.navCtrl.setRoot(HomePage);
    }, 2000);

  }
}
 


// WEBPACK FOOTER //
// ./src/pages/modal-inscricao/modal-inscricao.ts